module.exports = __webpack_public_path__ + "img/horizontal_4_5_pp2_1.60a177cf.png";